module.exports = __webpack_public_path__ + "img/claim-parking.0d57f482.svg";